export const homeCareRoutes = {
  'route.home-care.result': '/services/home-care/result/[id]',
  'route.home-care.index': '/services/home-care',
  'route.home-care.show': '/services/home-care/[id]/[cityId]',
  'route.home-care.checkout': '/services/home-care/checkout',

  'api.home-care.index': 'medical-services/create/[hashedLabId]',
  'api.home-care.show': 'medical-services/create/[hashedLabId]/[hashedServiceSubTypeId]',
  'api.home-care.tests': 'medical-services/create/test-list',
  'api.home-care.store': 'medical-services/data',
  'api.home-care.result': 'medical-services/data/[id]',
  'api.home-care.online-tracking': 'medical-services/online-tracking/[id]',
};
